/**
 * Allowed industries for filtering on the web frontend
 *
 * This list is used by both:
 * - ClientTags component (Clients page)
 * - CasesShowcase component (Cases page)
 *
 * Note: Names must match exactly the nameEN values from the Industries taxonomy API
 */
export const ALLOWED_INDUSTRIES = [
  'Travel',
  'Beauty',
  'Food',
  'Tech',
  'Fashion',
  'Sport',
  'Automobile',
] as const;

export type AllowedIndustry = (typeof ALLOWED_INDUSTRIES)[number];
